import FooterDivider from './FooterDivider';

export default FooterDivider;
